import styles from './formStatus.module.scss';

/**
 * Renders a form status component with a message and customizable color.
 *
 * @param props - The component props.
 * @param props.message - String containing the text message to show in the component.
 * @param props.show - Boolean to show or hide the component.
 * @param props.colour - String with the CSS class name for the different colors of the component.
 * @returns The rendered form status component.
 *
 * @example
 * ```tsx
 * <FormStatus
 *     message={formStatusData.message}
 *     show={formStatusData.show}
 *     colour={formStatusData.colour}
 * />
 * ```
 */
const FormStatus = ({
    message,
    show,
    colour,
}: {
    message: string;
    show: boolean;
    colour: string;
}) => {
    return (
        <div
            className={`${styles.container} ${styles[colour]} ${show ? styles.show : styles.hide}`}
        >
            <p className={styles.text}>{message}</p>
        </div>
    );
};

export default FormStatus;
